import openErrorModal from "../Error/ErrorModal";
import User from "../Models/User";
import { fetchUpdateUserModal, updateUser } from "../HTTPRequests/UserRequests";
import UserBaseModal from "./UserBaseModal";
import DeleteUserModal from "./DeleteUserModal";
import Mediator from "../Utilities/Mediator";

export default class UpdateUserModal extends UserBaseModal {

	constructor(createUserButton: HTMLButtonElement) {
		super(createUserButton);
	}

	public addUpdateModalsClickListeners() {
		const rows: NodeListOf<HTMLTableRowElement> = document.querySelectorAll('#users tbody tr');

		rows.forEach(row => {
			row.onclick = () => {
				document.body.append(this.loadingScreen);
				this.fetchUpdateModal(row);
			}
		});
	}

	private fetchUpdateModal(row: HTMLTableRowElement) {
		fetchUpdateUserModal(row.id)
			.then((response: string) => {
				this.openUpdateModal(response, row.id);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openUpdateModal(modalHTMLString: string, id: string) {
		const modalDiv: HTMLDivElement = document.createElement("div");
		modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(modalDiv);
		this.addPhonenumberValidationMsg(modalDiv);
		new DeleteUserModal(id, modalDiv).addDeleteModalClickListener();

		window.onclick = function (event) {
			if (event.target === modalDiv.firstElementChild) {
				modalDiv.remove();
			}
		}

		const img: HTMLImageElement = document.querySelector('#update-user-modal img[alt="close icon"]');
		img.onclick = () => {
			modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = document.querySelector('#save');
		saveButton.onclick = () => {
			this.saveUpdatedUser(id, modalDiv);
		}
	}

	private saveUpdatedUser(id: string, modalDiv: HTMLDivElement) {
		const form: HTMLFormElement = document.querySelector("#update-user-modal form");
		let { valid, data } = this.getModalData(form);
		form.onsubmit = event => event.preventDefault();
		delete data.storeId;

		if (valid) {
			data.id = id;
			document.body.append(this.loadingScreen);
			this.updateUser(data, modalDiv);
		} else {
			form.reportValidity();
		}
	}

	private updateUser(data: User, modalDiv: HTMLDivElement) {
		updateUser(data)
			.then(() => {
				modalDiv.remove();
				Mediator.emit("userCrudOperationFinished");
			}, (error) => { //backend error
				this.openErrorMsgModal(error);
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}
